import template from './timeline-item.html';
import './timeline-item.global.css';

export const TimelineItemComponent = {
  bindings: {
    filled: '@',
  },
  transclude: true,
  template,
};
